import { RoutePageType } from "@routes/interfaces"
import OperacaoLista from "./pages/OperacaoLista"

const operacaoPages: RoutePageType[] = [
    {key: 'cadastroOperacaoLista', element: OperacaoLista}
]

export default operacaoPages